@if (icon) {
<href [link]="iconLink || ''"
      class="_icon"
      [ngClass]="(iconRight ? 'm-l-' : 'm-r-')+ offset">
    <span [lineHeightBy]="textClass">
        <i [ngClass]="['icon-' + icon, iconSmall ? 'icon-small' : 'icon-medium']"></i>
    </span>
</href>
}

<span [ngClass]="[textClass]"
      class="inline-block va-m _copy">
    <ng-content />
</span>